<template>
  <div class="contentBox">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item v-if="abnormal == 'Purchase'">
        <el-radio-group class="chenckBox" v-model="radio">
          <div style="text-align: left">
            <el-radio :label="item.value" v-for="item in abnormals" :key="item.value" :disabled="item.disabled">{{ item.title }}</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="abnormal != 'Purchase'">
        <div class="chenckBox" v-for="item in abnormals" :key="item.value">
          <div style="text-align: left">
            <el-checkbox v-model="item.checked">{{ item.title }}</el-checkbox>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="(必填)采购手机号" v-if="isreceipt">
        <div class="flex">
          <el-input maxlength='250' v-model="expressPhone" placeholder="采购手机号" style="width: 150px;" @input="searchPurchase"/>
          <el-button type="primary" @click="() => {expressPhone = 18767163609;searchPurchase('18767163609')}">填入默认手机号</el-button>
        </div>
        <div style="text-align: left;">
          采购名称： {{ manageInfo.nickname || '-' }}
        </div>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input maxlength='250' type="textarea" :autosize="{ minRows: 5, maxRows: 4 }" v-model="textarea" placeholder="备注" />
      </el-form-item>
      <el-form-item label="图片">
        <div class="imgBlock">
            <div class="preview__li" v-for="(item, index) in images" :key="index">
              <!-- <ImgPreviews :images="[item.imgUrl]" width="100" height="100" /> -->
              <el-tooltip class="item" effect="light" placement="top" :disabled="disabledChoose">
                <div slot="content">
                  <div>
                    <el-checkbox v-model="item.outside" label="表面" border
                      @change="e => changeCheckbox(e, item, 'outside')"></el-checkbox>
                    <el-checkbox v-model="item.inside" label="内里" border
                      @change="e => changeCheckbox(e, item, 'inside')"></el-checkbox>
                  </div>
                  <br/>
                  <div style="margin-top: 6px;">
                    <el-checkbox v-model="item.normal" label="正品" border
                      @change="e => changeCheckbox(e, item, 'normal')"></el-checkbox>
                    <el-checkbox v-model="item.defective" label="次品" border
                      @change="e => changeCheckbox(e, item, 'defective')"></el-checkbox>
                  </div>
                </div>
                <el-image :src="item.imgUrl" :style="{ width: '100px', height: '100px' }"
                  :preview-src-list="[item.imgUrl]" alt="图片" class="previewsImage-tag">
                </el-image>
              </el-tooltip>
              <i class="el-icon-error" @click="delImg(item, index)"></i>
            </div>
          <el-upload class="uploader" :action="actionUrl" :on-change="uploadChange" :before-upload="beforeUpload"
            :data="uploadData" :http-request="uploadToOSS" :file-list="fileList" :show-file-list="false" v-if="images.length < 5">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="移动端上传扫码:">
        <canvas :id="canvasId" width="100" height="100" />
      </el-form-item>
      <el-form-item label="">
        <ul>
          <li v-if="!isreceipt">
            <el-input maxlength='450' v-model="abnormalAmount" style="width: 100px"></el-input>
          </li>
          <slot name="btn"></slot>
          <li>
            <el-button type="primary" @click="submit">
              {{ btnTitle }}
            </el-button>
          </li>
          <li>
            <el-button :loading="loading" @click="getImages"> 获取图片 </el-button>
          </li>
        </ul>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import IptNumber from "@/components/IptNumber";
import ImgPreviews from "@/components/ImgPreviews";

const addFlag = function (list) {
  return list.map((item, index) => {
    return { ...item, checked: index == 0 ? true : false };
  });
};
import QRCode from "qrcode";
import axios from "axios";
import { Descriptions } from "ant-design-vue";
import { getApplyCode, imgByCode, OSSsign, searchManageUserApi, imgSave, deleteImageApi } from "@/apis/inHouse";
export default {
  name: "Content",
  props: {
    btnTitle: {
      type: String,
      required: true, // 必填
    },
    abnormalType: {
      type: Array,
      required: true, // 必填
    },
    uploadId: {
      type: String,
    },
    isreceipt: {
      type: Boolean,
      default() {
        return false;
      },
    },
    abnormal: {
      type: String,
      required: true,
      default() {
        return "Purchase";
      },
    },
  },
  components: {
    [Descriptions.name]: Descriptions,
    [Descriptions.Item.name]: Descriptions.Item,
    ImgPreviews,
    IptNumber,
  },
  data() {
    return {
      canvasId: Math.random().toFixed(8),
      qrCode: this.uploadId || "",
      abnormalAmount: 0,
      abnormals: addFlag(JSON.parse(JSON.stringify(this.abnormalType))),
      textarea: "",
      loading: false,
      images: [],
      expressPhone: "",
      radio: "",
      actionUrl: "http://192.168.103.145/customer/oss/putOSS",
      fileList: [],
      uploadData: {},
      manageInfo: {}
    };
  },
  watch: {
    qrCode: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (!newVal) {
          return
        }
        this.$nextTick((_) => {
          let canvas = document.getElementById(this.canvasId);
          QRCode.toCanvas(canvas, newVal, function (error) {
            if (error) console.error(error);
          });
        });
      },
      immediate: true,
      keep: true,
    },
    abnormals: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.radio = newVal[0].value;
      },
      immediate: true,
      keep: true,
    },
    uploadId: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.expressPhone = "";
          this.images = [];
        }
      },
    },
  },
  mounted() {
    this.getCode();
  },
  computed: {},
  methods: {
    changeCheckbox(val, item, k) {
      if (val) {
        if (k === 'inside') {
          item.inside = true
          item.outside = false
        }
        if (k === 'outside') {
          item.inside = false
          item.outside = true
        }
        if (k === 'normal') {
          item.normal = true
          item.defective = false
        }
        if (k === 'defective') {
          item.normal = false
          item.defective = true
        }
      } else {
        item[k] = false
      }

      imgSave({
        imgDTOList: this.images.map(v => {
          const tagList = []
          const keys = ['outside', 'inside', 'normal', 'defective']
          keys.forEach((keyItem) => {
            if (v[keyItem]) {
              tagList.push(keyItem)
            }
          })
          return ({
            imgUrl: v.imgUrl,
            tagList: tagList
          })
        }),
        operationType: 1,
        picRelation: this.qrCode,
      })
    },
    getImages: function () {
      imgByCode({ picRelation: this.qrCode }).then(({ code, data }) => {
        if (code === 0) {
          this.images = data.map(v => ({
            ...v,
            outside: v.tagList?.includes('outside'),
            inside: v.tagList?.includes('inside'),
            normal: v.tagList?.includes('normal'),
            defective: v.tagList?.includes('defective')
          }));
        }
      });
    },
    submit: function () {
      const { abnormalAmount, qrCode, textarea, abnormals, radio } = this;
      if(radio === '104' && this.images.length === 0) {
        // 扫不出 图片必填
        this.$message.warning("请上传图片");
        return
      }
      const _abnormals = abnormals.filter((item) => item.checked).map((item) => item.value);
      let params = {
        abnormalAmount,
        qrCode,
        textarea,
        abnormal: _abnormals,
      };
      if (this.isreceipt) {
        params.expressPhone = this.expressPhone;
      }
      this.$emit("submitAbnormal", params);
      this.getCode()
    },
    getVal: function(){
      const { abnormalAmount, qrCode, textarea, abnormals } = this;
      const _abnormals = abnormals.filter((item) => item.checked).map((item) => item.value);
      let params = {
        abnormalAmount,
        qrCode,
        textarea,
        abnormal: _abnormals,
      };
      if (this.isreceipt) {
        params.expressPhone = this.expressPhone;
      }
      this.getCode()
      return params
    },
    getCode() {
      if (this.isreceipt) {
        return
      }
      let params = {
        num: 1,
      };
      getApplyCode(params).then(({ code, data }) => {
        if (code === 0) {
          this.qrCode = data[0];
        }
      });
    },
    beforeUpload(res) {
      console.log(res);
    },
    uploadChange(res) {
      console.log(res);
    },
    uploadToOSS(res) {
      console.log(res);
      // return false
      let name = String(Date.parse(new Date()) + res.file.name);
      let key = "transfer/" + name;
      OSSsign({ path: "transfer/" }).then(({ code, data }) => {
        console.log(data);
        let forms = new FormData();
        forms.append("name", name);
        forms.append("key", key);
        forms.append("OSSAccessKeyId", data.accessId);
        forms.append("policy", data.policy);
        forms.append("signature", data.signature);
        forms.append("success_action_status", 200);
        forms.append("file", res.file);
        // imageToOss(data.host, forms);
        let host = data.host
        if(location.href.indexOf('https')>-1&&host.indexOf('https')===-1){
          host = host.replace('http','https')
        }
        axios({
          method: "post",
          url: host,
          data: forms,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((res) => {
          console.log(res);
          if (res.status == 200) {
            this.saveImg(`${data.customDomain}/${key}`);
          }
        });
      });
    },
    saveImg(url) {
      console.log(url, this.qrCode);
      let parmas = {
        picRelation: this.qrCode,
        imgUrls: [url],
      };
      imgSave(parmas).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("添加成功");
          this.getImages()
        }
      });
    },
    //删除图片
    delImg(record, index) {
      deleteImageApi({
        id: record.id,
      }).then((res) => {
        this.$message.success('删除成功！')
        this.images.splice(index, 1);
      });
    },
    async searchPurchase(e){
      console.log(e)
      if(e.length === 11) {
        const {data} = await searchManageUserApi({
          mobile: e
        })
        console.log(data)
        if(data.manageUserId) {
          this.manageInfo = data
        }else {
          this.manageInfo = {}
        }
      }else {
        this.manageInfo = {}
      }
    }
  },
};
</script>

<style scoped>
.abnormal__div {
  display: grid;
  grid-template-columns: 120px auto 200px 140px;
  grid-column-gap: 20px;
}

.abnormal__div--qrCode {
  width: 180px;
  height: 150px;
  padding-right: 30px;
  position: relative;
  top: 0;
  left: 0;
}

.abnormal__div--qrCode>span {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 30px;
  height: 150px;
  text-align: center;
  writing-mode: vertical-lr;
}

.abnormal__div--qrCode span {
  font-weight: 600;
}

.abnormal__div--submit {
  padding: 20px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
}

.checkbox__div {
  height: 140px;
  background: #f8f8f9;
  border-radius: 10px;
  grid-column-start: 1;
  grid-column-end: 3;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  padding: 20px 400px 20px 20px;
  position: relative;
  top: 0;
  left: 0;
  /*grid-row-start: 1;*/
  /*grid-row-end: 2;*/
}

.checkbox__div--textarea {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 390px;
  height: 120px;
}

.checkbox__div--item {
  margin-right: 20px;
  margin-bottom: 14px;
  font-weight: 600 !important;
}

.imgBlock{
  display: flex;
  width: 340px;
  flex-wrap: wrap;
}

.preview__ul {
  display: flex;
  /* grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 3; */
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  box-sizing: border-box;
}

.preview__li {
  width: 100px;
  height: 100px;
  background: white;
  margin: 5px;
  position: relative;
}

.preview__li .el-icon-error {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 20px;
  cursor: pointer;
}

::v-deep .el-textarea textarea {
  height: 120px;
}

.contentBox {
  display: flex;
  flex-direction: column;
}

.chenckBox {
  width: 120px;
}

.phoneBox {
  width: 240px;
}

.uploader {
  border: 1px solid #eee;
  height: 100px;
  width: 100px;
  margin: 5px;
}

.uploader i {
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
